module.exports = __webpack_public_path__ + "static/media/es-ES.7ecfca21.md";